import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Tabs } from 'antd';
import Task from './task';
import Manuscript from './manusctipt';
import './index.scss';

const { TabPane } = Tabs;
const CommonWrap = (props) => {

    const [activeKey, setActiveKey] = useState("1");

    const changeTab = (activeKey) => {
        setActiveKey(activeKey);
    }

    const renderContent = () => {
        if(activeKey === "1"){
            return <Task newSecondSelectColor={newSecondSelectColor}  title={props.title}/>
        }else{
            return <Manuscript title={props.title} />
        }
    }

    let height = window.innerHeight - 70;
    let newSecondSelectColor = props.config && props.config.getValueByKey ? props.config.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
    return(
        <div className="common-wrap" style={{ height }}>
            <div className="top">
                <div className="left" style={{color:newSecondSelectColor}}>{props.title}</div>
                <div className="right">
                    <Tabs defaultActiveKey="1" centered onChange={changeTab}>
                        {
                            props.tabs && props.tabs.map((item) => (
                                <TabPane tab={item.tab} key={item.id}>
                                </TabPane>
                            ))
                        }
                    </Tabs>
                    <style>
                            {`
                          
            
            .right  .ant-tabs-bar .ant-tabs-tab-active {
              color:${newSecondSelectColor}!important ;
              font-weight:bold !important;
             font-size:16px !important;
                }
                .right  .ant-tabs-nav-container  {
             font-size:16px !important;
                }
              .right .ant-tabs-ink-bar{
                background-color:  ${newSecondSelectColor} !important;
                }
               .right  .ant-tabs-nav .ant-tabs-tab {
               color: #6c748b;
               font-weight:bold !important;
               }
             .right  .ant-tabs-nav .ant-tabs-tab:hover {
                color: ${newSecondSelectColor} !important;
            }
                             `}
                        </style>
                </div>
            </div>
            <div className="wrap">
                {renderContent()}
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    return {
        config: state.systemReducer.config,
    }
}

export default connect(mapStateToProps)(CommonWrap);
